// extracted by mini-css-extract-plugin
export var widgetContainer = "widget-container__kR911";